import React from 'react';

import { Page } from '@components';
import { Col, Row } from 'antd';
import { Title } from '@styles/components/text';
import { SendedOrdersBody } from './components/sended-orders-body';
import { translate } from '@components/i18n';

export const SendedOrders: React.FC = () => {
    return (
        <Page title={translate('pages.sendOrders')} greyBackground withPadding>
            <Row>
                <Col span={1} />
                <Col span={22}>
                    <Row>
                        <Title marginTop={20} level={3}>
                            {translate('titlePages.sendOrders')}
                        </Title>
                    </Row>
                    <SendedOrdersBody />
                </Col>
                <Col span={1} />
            </Row>
        </Page>
    );
};
